<template>
  <div class="base-toggle">
    <label class="base-toggle__switch">
      <input 
        :class="{ active: value }" 
        type="base-toggle__switch-input"
      >
      <span 
        class="base-toggle__switch-slider round" 
        @click="toggle()"
      />
    </label>
    <div class="base-toggle__label">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "value",
    event: "input",
  },
};
</script>

<script setup>
const props = defineProps({
  value: Boolean,
});

const emit = defineEmits(["input"]);

const toggle = () => {
  emit("input", !props.value);
};
</script>

<style lang="scss" scoped>
@import "./base-toggle.scss";
</style>
